import React from 'react';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    XStack,
    YStack,
} from 'smoothie';

import {
    MONEY_MAPPER_YOUR_MONEY_SUB_OPTIONS,
    type MoneyMapperYourMoneySubSegment,
} from './moneyMapperNavigation';

interface MoneyMapperYourMoneyTabBarProps {
    selected: MoneyMapperYourMoneySubSegment;
    onValueChange: (segment: MoneyMapperYourMoneySubSegment) => void;
}

export const MoneyMapperYourMoneyTabBar = ({
    selected,
    onValueChange,
}: MoneyMapperYourMoneyTabBarProps) => {
    return (
        <YStack width="100%" paddingBottom={8}>
            <XStack
                width="100%"
                alignItems="flex-end"
                justifyContent="flex-start"
                flexWrap="wrap"
                borderBottomWidth={1}
                borderBottomColor="$gray900"
            >
                {MONEY_MAPPER_YOUR_MONEY_SUB_OPTIONS.map(({ value, label }) => {
                    const isSelected = selected === value;
                    return (
                        <YStack
                            key={value}
                            onPress={() => {
                                onValueChange(value);
                            }}
                            cursor="pointer"
                            paddingBottom={6}
                            paddingRight={24}
                        >
                            {isSelected ? (
                                <BodyMediumEmphasized color="$black">
                                    {label}
                                </BodyMediumEmphasized>
                            ) : (
                                <BodyMediumRegular color="$gray900">
                                    {label}
                                </BodyMediumRegular>
                            )}
                        </YStack>
                    );
                })}
            </XStack>
        </YStack>
    );
};
